import React,{useRef,useState,useEffect} from 'react';
import {useComponentHeightWithRef} from "./useComponentHeight"
import { useScrollDirection } from "./useScrollDirection";

const DataContainer = ({ style, header,footer, children,showHeader=true,scrollable=true,hideHeaderWhenScollUp=false,innerContextStyle={}}) => {
  const refHeader = useRef(null)
  const refFooter = useRef(null)
  const containerRef = useRef(null)
  const headerHeight = useComponentHeightWithRef(refHeader);
  const footerHeight = useComponentHeightWithRef(refFooter);
  const [hideHeader,setHideHeader] = useState(!showHeader);
  useEffect(()=>{
    setHideHeader(!showHeader)
  },[showHeader])
  useScrollDirection({
    ref: containerRef,
    onSwipe:(direction,top)=>{
      switch(direction){
          case "down":{
            setHideHeader(false);
            break;
          }
          case "up":{
            if(top>50){
              setHideHeader(true);
            }
            break;
          }
        }
    },
    enable:scrollable && hideHeaderWhenScollUp,
    threshold:10,
    bottomOffset:800,
  });
  
  return (
    <div class="flex-data-container" style={{...style,display:"flex",flexDirection:"column",overflow: "hidden",position:"relative"}}>
      <div 
        class="flex-data-container-header"
        style={{ 
          position: "sticky", 
          top: 0, 
          left: 0, 
          right: 0,
          height: !hideHeader ? `${headerHeight}px` : '0px',
          transition: 'height 0.3s ease-in-out',
          overflow: 'hidden',
          zIndex:1299
        }}
      >
        <div ref={refHeader}>
             {header}
        </div>
       
      </div>
      <div
        style={{
          flex: 1,
          overflow: scrollable?"auto":"hidden",
        }}
        ref={containerRef}
        class="flex-data-container-content"
      >
        <div style={{ minHeight: `calc(100% - ${footerHeight||0}px)`,height:scrollable?undefined:"100%",paddingBottom:scrollable?footerHeight:0,...innerContextStyle }}>
          {children}
        </div>
      </div>
      <div 
        ref={refFooter}
        class="flex-data-container-footer"
        style={{ 
          position: scrollable?"absolute":"static", 
          bottom: 0, 
          left: 0, 
          right: 0,
          zIndex:1299
        }}
      >
        {footer}
      </div>
    </div>
  );
};

export default DataContainer;